import React from "react";
import ReactMarkdown from "react-markdown";
import { Broadcast, Paperclip, Flask } from "@phosphor-icons/react";

export default function MessageBubble({ msg, onSave }) {
  const isUser = msg.role === "user";
  const sensorNames = msg.sensorData?.sensors
    ? msg.sensorData.sensors.map((s) => s.name.split(" /")[0]).join(", ")
    : "";
  return (
    <div data-testid={`message-${msg.role}`} className={`flex ${isUser ? "justify-end" : "justify-start"} px-4`}>
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-3 text-[15px] leading-relaxed border ${
          isUser ? "bg-volt border-volt/50 rounded-br-md" : "bg-elevated border-white/10 rounded-bl-md"
        }`}
      >
        {msg.sensorData && msg.sensorData.sensors && (
          <div className="flex items-center gap-1.5 text-xs bg-black/25 rounded-lg px-2.5 py-1.5 mb-2 font-medium">
            <Broadcast size={14} weight="bold" />
            <span>
              Sensordaten: {sensorNames} ({msg.sensorData.window?.duration} s)
            </span>
          </div>
        )}
        {msg.attachments && msg.attachments.length > 0 && (
          <div className="flex items-center gap-1.5 text-xs bg-black/25 rounded-lg px-2.5 py-1.5 mb-2 font-medium">
            <Paperclip size={14} weight="bold" />
            <span>{msg.attachments.join(", ")}</span>
          </div>
        )}
        {isUser ? (
          <div className="whitespace-pre-wrap break-words">{msg.content}</div>
        ) : (
          <div className="markdown-body break-words">
            <ReactMarkdown>{msg.content}</ReactMarkdown>
            {msg.streaming && <span className="stream-cursor" />}
          </div>
        )}
        {!isUser && !msg.streaming && (msg.mode === "pro" || onSave) && (
          <div className="flex items-center justify-between gap-3 mt-2">
            {msg.mode === "pro" ? (
              <span className="text-[10px] uppercase tracking-widest font-bold text-volt">Pro-Antwort</span>
            ) : (
              <span />
            )}
            {onSave && (
              <button
                data-testid="save-experiment-btn"
                onClick={onSave}
                className="flex items-center gap-1 text-xs font-semibold text-volthover hover:text-white transition-colors"
              >
                <Flask size={14} weight="duotone" /> Als Experiment speichern
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
